"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
const ActionType_1 = require("./actions/ActionType");
function reducer(state, action) {
    switch (action.type) {
        case ActionType_1.ActionType.SetPreviewImage:
            return Object.assign(Object.assign({}, state), { previewImage: action.payload.previewImage });
        case ActionType_1.ActionType.SetSelectedPhenotype:
            return Object.assign(Object.assign({}, state), { selectedPhenotype: action.payload.selectedPhenotype });
        case ActionType_1.ActionType.SetSelectedSex:
            return Object.assign(Object.assign({}, state), { selectedSex: action.payload.selectedSex });
        case ActionType_1.ActionType.SetSkinTone:
            return Object.assign(Object.assign({}, state), { selectedSkinTone: action.payload.selectedSkinTone });
        case ActionType_1.ActionType.SetIsOnboarding:
            return Object.assign(Object.assign({}, state), { isOnboarding: action.payload.isOnboarding });
        default:
            return state;
    }
}
exports.reducer = reducer;
